module.exports = __webpack_public_path__ + "img/magical-book.9aed0931.jpg";